import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import type {
    ISportOfferState,
    SportOfferGetters,
} from './types';

function defaultState(): ISportOfferState {
    return {
        sports: {},
        categories: {},
        tournaments: {},
        markets: {},
        marketGroupInfos: {},
        oddTypes: {},
        marketTree: {},
        events: {},
        oddValueDynamics: {},
        topTenEvents: [],
        topEventIds: [],
        isOfferStarting: false,
        isOfferReady: false,
        areLiveEventsFetched: false,
        isStructFetched: false,
        featuredTournaments: {},
        liveEventsCount: null,
        promotionalEvents: {},
        allChangesIncrementId: 0,
        areSubscriptionsSet: false,
        isEventsSubscriptionSet: false,
        isOfferFetched: false,
        isOfferFetchedBySport: {},
        isSuperOfferFetched: false,
        areTopTenEventsFetched: false,
        areTopEventIdsFetched: false,
        competitionTreeBySportId: {},
        isCompetitionTreeFetchBySportId: {},
        // On very first message from SSE we should call REST sync,
        // but we skip that sync because we have just fetched whole offer/struct
        isFirstDailyOfferSync: true,
        isFirstStructSync: true,
        sportDatesWithActiveOffer: {},
        sportsWithEvents: [],
        popularSuperbets: [],
        popularSuperbetsV2: [],
    };
}

const store = {
    mutations,
    actions,
    getters,
    namespaced: true,
    state: defaultState(),
};

export default store;
export type SportOfferDataStore = typeof store;

export {
    ISportOfferState,
    SportOfferGetters,
};
